import { TemplatePortal } from '@angular/cdk/portal';
import { CdkStep, STEPPER_GLOBAL_OPTIONS, StepperOptions } from '@angular/cdk/stepper';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  forwardRef,
  Inject,
  OnDestroy,
  Optional,
  ViewContainerRef,
} from '@angular/core';
import { map, startWith, Subscription, switchMap } from 'rxjs';

import { NStepContentDirective } from './n-step-content.directive';
import { NStepLabelDirective } from './n-step-label.directive';
import { NStepperComponent } from './n-stepper.component';

/* eslint-disable no-underscore-dangle */
@Component({
  selector: 'n-step',
  templateUrl: 'n-step.component.html',
  providers: [{ provide: CdkStep, useExisting: NStepComponent }],
  exportAs: 'nStep',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NStepComponent extends CdkStep implements AfterContentInit, OnDestroy {
  /** Content for step label given by `<ng-template nStepLabel>`. */
  @ContentChild(NStepLabelDirective) override stepLabel: NStepLabelDirective;

  /** Content that will be rendered lazily. */
  @ContentChild(NStepContentDirective, { static: false }) lazyContent: NStepContentDirective;

  /** Currently-attached portal containing the lazy content. */
  portal: TemplatePortal;

  private isSelected = Subscription.EMPTY;

  constructor(
    @Inject(forwardRef(() => NStepperComponent)) stepper: NStepperComponent,
    private viewContainerRef: ViewContainerRef,
    @Optional() @Inject(STEPPER_GLOBAL_OPTIONS) stepperOptions?: StepperOptions,
  ) {
    super(stepper, stepperOptions);
  }

  ngAfterContentInit() {
    this.isSelected = this._stepper.steps.changes
      .pipe(
        switchMap(() =>
          this._stepper.selectionChange.pipe(
            map((event) => event.selectedStep === this),
            startWith(this._stepper.selected === this),
          ),
        ),
      )
      .subscribe((isSelected) => {
        if (isSelected && this.lazyContent && !this.portal) {
          this.portal = new TemplatePortal(this.lazyContent.template, this.viewContainerRef);
        }
      });
  }

  ngOnDestroy() {
    this.isSelected.unsubscribe();
  }
}
